import type { FC } from 'react';
import React from 'react';

import type {
  AvatarWrapperProps,
  ILoginSocialBarProps,
} from '../../../../LoginSocialBar.types';
import AvatarWrapper from '../avatar';

import styles from './LoggedOffSocialBar.module.scss';
import { TEST_ID_HANDLE_BUTTON } from '../../../../constants';

type LoggedOffSocialBarProps = Omit<
  AvatarWrapperProps,
  'avatarUri' | 'isLoggedIn' | 'userName'
> &
  Pick<ILoginSocialBarProps, 'translations'> & {
    handleLogin: () => void;
    reportBiOnClick: (label: string) => void;
  };

export const LoggedOffSocialBar: FC<LoggedOffSocialBarProps> = ({
  handleLogin,
  id,
  translations,
  reportBiOnClick,
  customAvatar,
  avatarIcon,
  useNewMemberInitialsAvatar,
}) => {
  const onClick = React.useCallback(() => {
    reportBiOnClick(translations.loggedOutText!);
    handleLogin();
  }, [translations.loggedOutText, handleLogin, reportBiOnClick]);

  return (
    <button
      className={styles.login}
      onClick={onClick}
      data-testid={TEST_ID_HANDLE_BUTTON}
    >
      <AvatarWrapper
        id={id}
        isLoggedIn={false}
        customAvatar={customAvatar}
        avatarIcon={avatarIcon}
        useNewMemberInitialsAvatar={useNewMemberInitialsAvatar}
      />
      <span className={styles.logOutText}>{translations.loggedOutText}</span>
    </button>
  );
};
